<template>
  <div>
    <div class="searchBox">
      <div class="searchLeft">
        <el-date-picker
        size="medium"
          v-model="searchForm.startTime"
          type="date"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptionsStart"
          placeholder="请选择开始时间">
        </el-date-picker>
        <el-date-picker
          size="medium"
          v-model="searchForm.endTime"
          type="date"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptionsEnd"
          placeholder="请选择结束时间">
        </el-date-picker>
        <el-button size="medium" type="primary" icon="el-icon-search" @click="getTableList">搜索</el-button>
        <a
            :href="url+'/cooperateInfo/export?startTime='+searchForm.startTime + '&&endTime='+searchForm.endTime" style="margin-left:20px">
            <el-button size="medium" type="warning" icon="el-icon-folder-opened">导出</el-button>
        </a>
      </div>
   
    </div>
    <el-table
      border
      :data="tableData"
      height="73vh"
      style="width: 100%">
      <el-table-column
        width="160px"
        label="提交时间">
         <template slot-scope="scope">
             <span>{{translateTime(scope.row.createTime)}}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        label="名称">
      </el-table-column>
      <el-table-column
        prop="phoneNumber"
        label="电话号码">
      </el-table-column>
      <el-table-column
        prop="mail"
        label="邮箱">
      </el-table-column>
      <el-table-column
        prop="other"
        label="其他">
      </el-table-column>
     
      <el-table-column
        prop="region"
        label="地区信息">
      </el-table-column>
      <el-table-column
        fixed="right"
        max-width="200px"
        label="操作">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="onDetail(scope.row)"><i class="el-icon-view" style="margin-right:3px;" ></i>查看详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pageBox" v-if="totalNum > 0">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchForm.page"
          :page-sizes="[20, 30, 40]"
          :page-size="searchForm.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum"
        >
        </el-pagination>
    </div>

    <el-dialog
      title="信息详情"
      :visible.sync="orderModuleDialog"
      class="nodeModules"
      width="800px">
      <div class="userInfo_box" style="" v-if="infoDetail">
        <div class="sam_box">
          <div>名称: {{infoDetail.name}}</div>
          <div>提交时间: {{translateTime(infoDetail.createTime)}}</div>
          <div>电话号码: {{infoDetail.phoneNumber}}</div>
          <div>邮箱: {{infoDetail.mail}}</div>
          <div>其他: {{infoDetail.other}}</div>
          <div>地区信息: {{infoDetail.region}}</div>
          <div>信息介绍:</div>
          <div class="desc_text">{{infoDetail.inforIntroduce}}</div>
          <div>合作需求:</div>
          <div class="desc_text">{{infoDetail.needs}}</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
     return {
      pickerOptionsStart: {
        disabledDate: time => {
          let endDateVal = this.searchForm.endTime;
          if (endDateVal) {
            return time.getTime() > new Date(endDateVal).getTime()
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          let beginDateVal = this.searchForm.startTime;
          if (beginDateVal) {
            return (time.getTime()<new Date(beginDateVal).getTime()-1*24*60*60*1000)
          }
        }
      },
      orderModuleDialog: false,
      totalNum:0,
      searchForm:{
        startTime:'',
        endTime:'',
        page:1,
        pageSize:20,
      },
      tableData: [],  
      infoDetail: {},
      url: window.g.host
    };
  },
  created() {
    this.getTableList()
    
  },
  methods: {
    translateTime(date) {
        let d = new Date(date)
        return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()} ${d.getHours()}:${d.getMinutes()}:${d.getSeconds()}`
    },

    onDetail(row) {
      this.infoDetail = row
      this.orderModuleDialog = true
    },

    async getTableList(val){
      if(val){
        this.searchForm.page = 1;
      }
       let res = await this.$http.cooperateListApi({...this.searchForm});
        if (res) {
          this.tableData=res.data.list
          this.totalNum=Number(res.data.totalSize)
        }
    },

    handleSizeChange(val) {
      this.searchForm.page = 1;
      this.searchForm.pageSize = val;
      this.getTableList();
    },
    handleCurrentChange(val) {
      this.searchForm.page = val;
      this.getTableList();
    }
  }
};
</script>
<style scoped>

.desc_text {
  height: 100px;
  overflow: scroll;
  margin-left: 20px;
}
.sam_box{
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
}
.sam_box div{
  /* width: 210px; */
  margin-top: 10px;
}


</style>
<style>
.nodeModules .el-dialog__body{
  padding:0  20px  20px;
}
.nodeModules .el-radio{
  width: 100%;
  margin-bottom: 20px;
}
</style>
